
import React from "react";
import { motion } from "framer-motion";

const Team = () => {
  const teamMembers = [
    {
      name: "Pedro",
      role: "Presidente",
      description: "Jubilado, más de 20 años viviendo en El Coto, anterior vicepresidente"
    },
    {
      name: "Ana",
      role: "Vicepresidenta",
      description: "Trabajadora con dos hijos y preocupada por la seguridad de la urbanización, la accesibilidad al pueblo y el mantenimiento de las zonas comunes"
    },
    {
      name: "Mar",
      role: "Secretaria",
      description: "Madre trabajadora en el sector IT, responsable de ésta página y de garantizar un uso eficiente de los recursos tecnológicos de la comunidad"
    },
    {
      name: "Eva",
      role: "Vocal",
      description: "Recién jubilada y con ganas de aportar ideas y soluciones"
    },
    {
      name: "Aura",
      role: "Vocal",
      description: "Llevo dos meses en El Coto y me gusta formar parte del día a día de la comunidad"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-bold text-primary mb-4">
            Nuestro Equipo Gestor
          </h1>
          <p className="text-xl text-gray-600">
            Conoce a las personas comprometidas con el futuro de El Coto
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white rounded-lg shadow-lg p-6"
            >
              <h3 className="text-xl font-semibold mb-2">{member.name}</h3>
              <p className="text-primary font-medium mb-3">{member.role}</p>
              <p className="text-gray-600">{member.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Nueva sección de Nuestra Gestión */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="bg-white rounded-lg shadow-lg p-8 mb-16"
        >
          <h2 className="text-2xl font-bold mb-6">Nuestra Gestión</h2>
          <div className="space-y-6 text-gray-600">
            <p>
              Durante el último año hemos racionalizado gastos, reducido considerablemente 
              la deuda de la comunidad y eliminado gastos superfluos lo que se ha traducido 
              en una reducción de la cuota a la comunidad.
            </p>
            <p>
              Además, hemos mantenido reuniones con el Ayuntamiento con el fin de que se 
              mejoren las inversiones en nuestra comunidad y de que, cualquiera que sea el 
              equipo de gobierno, invierta en nuestros parques, zonas comunes, infraestructura 
              y seguridad.
            </p>
            <p>
              Seguiremos trabajando en reducción de deuda y eliminación de gastos lo que se 
              traducirá en nuevas bajadas de cuotas comunitarias y fomentar una relación de 
              confianza con el Ayuntamiento.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="bg-white rounded-lg shadow-lg p-8"
        >
          <h2 className="text-2xl font-bold mb-4">Nuestros Valores</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-2">Compromiso</h3>
              <p className="text-gray-600">
                Dedicación total a la mejora continua de nuestra urbanización
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2">Transparencia</h3>
              <p className="text-gray-600">
                Comunicación clara y honesta con todos los vecinos
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2">Innovación</h3>
              <p className="text-gray-600">
                Búsqueda constante de soluciones modernas y eficientes
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Team;
